import React, { useEffect } from "react";
import { IDecrementalTableReport } from "../../../Interfaces/deltaHedgeSettings";
import { ITableUI } from "../../TableTemplate/tableTemplate";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import {
  setDecrementalTableFlag,
} from "../../../Features/DeltaHedgeSettings/deltaHedgeSettingsSlice";
import { CommonTableUI } from "../../TableTemplate/common";

const TableUI: React.FC<ITableUI<IDecrementalTableReport>> = ({
  reports,
  onAction,
  AdditionalBody,
}: ITableUI<IDecrementalTableReport>) => {
  const flag = useAppSelector(
    (store) => store.deltaHedgeSettingsSlice.decrementalTableRefetchFlag
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!!flag && onAction) {
      dispatch(setDecrementalTableFlag(false));
      onAction();
    }
  }, [flag]);
  return (
    <CommonTableUI
      reports={reports}
      onAction={onAction}
      AdditionalBody={AdditionalBody}
    />
  );
};

export default TableUI;
